(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-faq-single"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".accordion-item").forEach((item) => {
      const title = item.querySelector(".accordion-title");

      title.addEventListener("click", () => {
        item.classList.toggle("open");
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.lastScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 0) {
        this.classList.add('scrolled');
      } else {
        this.classList.remove('scrolled');
      }

      this.lastScrollTop = scrollTop;
    }

  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    // Menu Open/Close
    const html = document.documentElement;
    const btn = document.getElementById('menuBtn');
    const closeBtn = document.getElementById('menuClose');
    const target = document.getElementById('menu');

    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
      target.classList.toggle('active');
      html.classList.toggle('menu-open');
    });

    // Search Open/Close
    // const searchBtn = document.getElementById('searchOpen');
    // const searchBox = document.getElementById('searchBox');
    // const searchClose = document.getElementById('searchBoxClose');
    
    // searchBtn.addEventListener('click', () => {
    //   searchBox.classList.remove('hidden');
    // });
    // searchClose.addEventListener('click', () => {
    //   searchBox.classList.add('hidden');
    // });
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const modalOpen = document.querySelector('#modalOpen');
    const modalEl = document.querySelector('#modal');
    const modalClose = document.querySelector('#modalClose');
    if (modalEl) {
      modalOpen.addEventListener("click", () => {
        modalEl.classList.add("active");
      });
      modalClose.addEventListener("click", () => {
        modalEl.classList.remove("active");
        const youtubeIframe = modalEl.querySelector('.js-youtube');
        const vimeoIframe = modalEl.querySelector('.js-vimeo');
        if (youtubeIframe) {
          youtubeIframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        if (vimeoIframe) {
          vimeoIframe.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.header.classList.add('!z-[998]');
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      this.currentScrollTop = 0;
      this.lastScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isScrollingDown = scrollTop > this.lastScrollTop;

      if (isScrollingDown && scrollTop > 50) {
        this.classList.add('scrolled');
      } else if (!isScrollingDown) {
        this.classList.remove('scrolled');
      }

      this.lastScrollTop = scrollTop;
    }

  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    // Menu Open/Close
    const btn = document.getElementById('menuBtn');
    const closeBtn = document.getElementById('closeMenu');
    const mobileBtn = document.getElementById('mobileBtn');
    const target = document.getElementById('megaMenu');

    btn.addEventListener('click', () => {
      target.classList.toggle('active');
    });
    
    closeBtn.addEventListener('click', () => {
      target.classList.remove('active');
    });

    mobileBtn.addEventListener('click', () => {
      target.classList.toggle('active');
    });

    // Search Open/Close
    const searchBtn = document.getElementById('searchOpen');
    const searchBox = document.getElementById('searchBox');
    const searchClose = document.getElementById('searchBoxClose');
    
    searchBtn.addEventListener('click', () => {
      searchBox.classList.remove('hidden');
    });
    searchClose.addEventListener('click', () => {
      searchBox.classList.add('hidden');
    });
  });
  

  } catch(e) { console.error(e); }
})();
})();
